<template>
    <v-container fluid>
        <v-row>
            <v-col class="pl-5">
                <v-btn v-if="inEditMode && entity.id != 0" class="ml-2 mr-2" color="primary" @click="saveClick(false)">
                    <v-icon small>fa-save</v-icon>&nbsp;{{ $t('buttons.save') }}
                </v-btn>
                <v-btn v-if="inEditMode" class="ml-2 mr-2" color="primary" @click="saveClick(true)">
                    <v-icon small>fa-save</v-icon>&nbsp;{{ $t('buttons.saveAndExit') }}
                </v-btn>
                <v-btn v-if="!inEditMode" class="ml-2 mr-2" color="primary" @click="editClick()">
                    <v-icon small>fa-edit</v-icon>&nbsp;{{ $t('buttons.edit') }}
                </v-btn>
                <v-btn class="mr-2" @click="backClick">
                    <v-icon small>fa-reply</v-icon>&nbsp;{{ $t('buttons.back') }}
                </v-btn>
            </v-col>
            <v-col class="text-right ml-0 pl-0" v-if="entity.id != 0">
                <v-btn class="ml-0 mr-2 mt-1" color="primary" @click="generateAndApproveTimesheets()">
                    <v-icon class="mr-2" small>fas fa-table</v-icon>{{ $t('buttons.generateAndApproveTimesheets') }}
                </v-btn></v-col
            >

            <v-col cols="12" v-if="entity.id == 0">
                <v-card flat>
                    <v-card-text>
                        <v-row dense>
                            <v-col cols="2">
                                <Dropdown
                                    v-model="template_id"
                                    :ajax="true"
                                    :data="'entities'"
                                    :label="$t('fields.loadFromTemplate')"
                                ></Dropdown>
                            </v-col>
                            <v-col cols="2">
                                <v-btn
                                    class="ml-2 mr-2 mt-1"
                                    color="primary"
                                    @click="loadFromTemplate()"
                                    :disabled="template_id == null"
                                >
                                    <v-icon class="mr-2" small>fas fa-paste</v-icon>{{ $t('buttons.load') }}
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
            <!-- <v-col cols="12" v-if="entity.id != 0 && $myStore.state.user.user_role_id == 1">
                <v-card flat>
                    <v-card-text>
                        <v-row dense>
                            <v-col cols="12" class="text-right">
                                <v-btn class="ml-2 mr-2 mt-1" color="primary" @click="sendAllTimesheetsToBilling()">
                                    <v-icon class="mr-2" small>fas fa-file-import</v-icon
                                    >{{ $t('buttons.sendTimesheetsToBilling') }}
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col> -->
        </v-row>
        <v-row class="pl-5" v-if="entity.id != 0">
            <v-col class="text-right ml-0 pl-0">
                <v-btn class="ml-0 mr-2 mt-1" color="primary" @click="sendAllTimesheetsToBilling()">
                    <v-icon class="mr-2" small>fas fa-file-import</v-icon>{{ $t('buttons.sendTimesheetsToBilling') }}
                </v-btn></v-col
            >
        </v-row>
        <v-row
            style="
                margin-top: 3px;
                margin-bottom: 0px;
                scroll-margin: 0px;
                height: 82vh;
                overflow-y: scroll;
                overflow-x: hidden;
            "
        >
            <v-col cols="12" xl="6" lg="6" md="6">
                <v-card flat>
                    <v-card-title>
                        {{ $t('labels.entityDetails') }}
                    </v-card-title>
                    <v-card-text>
                        <v-row dense wrap>
                            <v-col cols="5" v-if="entity.id != 0">
                                <InputField :readonly="true" v-model="entity.id" :label="$t('fields.id')"></InputField>
                            </v-col>
                            <v-col cols="2" class="pt-0">
                                <CheckBox
                                    :readonly="!inEditMode"
                                    v-model="entity.active"
                                    :label="$t('fields.active')"
                                ></CheckBox>
                            </v-col>
                            <v-col v-if="entity.id != 0" cols="5"></v-col>
                            <v-col v-if="entity.id == 0" cols="10"></v-col>

                            <v-col cols="12" v-if="entity.id != 0">
                                <DatePicker
                                    :readonly="true"
                                    v-model="entity.registration_date"
                                    :errorBorder="!entityValidation.registration_date"
                                    :date-label="$t('fields.registrationDate')"
                                ></DatePicker>
                            </v-col>
                            <v-col cols="12">
                                <InputField
                                    :readonly="!inEditMode"
                                    :maxlength="150"
                                    v-model="entity.name"
                                    :errorBorder="!entityValidation.name"
                                    :label="'* ' + $t('fields.name')"
                                ></InputField>
                            </v-col>
                            <v-col cols="12">
                                <InputField
                                    :readonly="!inEditMode"
                                    :maxlength="50"
                                    v-model="entity.town"
                                    :errorBorder="!entityValidation.town"
                                    :label="'* ' + $t('fields.town')"
                                ></InputField>
                            </v-col>
                            <v-col cols="12">
                                <InputField
                                    :readonly="!inEditMode"
                                    :maxlength="50"
                                    v-model="entity.address"
                                    :errorBorder="!entityValidation.address"
                                    :label="'* ' + $t('fields.address')"
                                ></InputField>
                            </v-col>
                            <v-col cols="12">
                                <InputField
                                    :readonly="!inEditMode"
                                    :maxlength="50"
                                    v-model="entity.post_code"
                                    :errorBorder="!entityValidation.post_code"
                                    :label="'* ' + $t('fields.postalCode')"
                                ></InputField>
                            </v-col>
                            <v-col cols="12">
                                <Dropdown2
                                    :readonly="!inEditMode"
                                    v-model="entity.country_id"
                                    :ajax="true"
                                    :data="'countries'"
                                    :errorBorder="!entityValidation.country_id"
                                    :label="'* ' + $t('fields.country')"
                                ></Dropdown2>
                            </v-col>
                            <v-col cols="12">
                                <Dropdown
                                    :readonly="!inEditMode"
                                    v-model="entity.entity_type_id"
                                    :ajax="true"
                                    :data="'entity-types'"
                                    :errorBorder="!entityValidation.entity_type_id"
                                    :label="'* ' + $t('fields.type')"
                                ></Dropdown>
                            </v-col>
                            <v-col cols="12">
                                <TextArea
                                    :readonly="!inEditMode"
                                    :maxlength="500"
                                    v-model="entity.notes"
                                    :errorBorder="!entityValidation.notes"
                                    :label="$t('fields.notes')"
                                ></TextArea>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
                <v-card flat>
                    <v-card-title>
                        {{ $t('labels.pointOfContact') }}
                    </v-card-title>
                    <v-card-text>
                        <v-row dense wrap>
                            <v-col cols="12">
                                <InputField
                                    :readonly="!inEditMode"
                                    :maxlength="50"
                                    v-model="entity.poc_name"
                                    :errorBorder="!entityValidation.poc_name"
                                    :label="$t('fields.name')"
                                ></InputField>
                            </v-col>
                            <v-col cols="12">
                                <InputField
                                    :readonly="!inEditMode"
                                    :maxlength="20"
                                    v-model="entity.poc_phone"
                                    :errorBorder="!entityValidation.poc_phone"
                                    :label="$t('fields.phone')"
                                ></InputField>
                            </v-col>
                            <v-col cols="12">
                                <InputField
                                    :readonly="!inEditMode"
                                    :maxlength="50"
                                    v-model="entity.poc_email"
                                    :errorBorder="!entityValidation.poc_email"
                                    :label="$t('fields.emailTo')"
                                ></InputField>
                            </v-col>
                            <v-col cols="12">
                                <InputField
                                    :readonly="!inEditMode"
                                    :maxlength="100"
                                    v-model="entity.poc_cc"
                                    :errorBorder="!entityValidation.poc_cc"
                                    :label="$t('fields.cc')"
                                ></InputField>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
                <v-card flat>
                    <v-card-title>
                        {{ $t('labels.contacts') }}
                    </v-card-title>
                    <v-card-text>
                        <v-simple-table>
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <th class="text-left">{{ $t('fields.name') }}</th>
                                        <th class="text-left">{{ $t('fields.phone') }}</th>
                                        <th class="text-left">{{ $t('fields.email') }}</th>
                                        <th class="text-left" v-if="inEditMode">{{ $t('buttons.delete') }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, index) in entityContacts" :key="index">
                                        <td>{{ item.name }}</td>
                                        <td>{{ item.phone }}</td>
                                        <td>{{ item.email }}</td>
                                        <td class="pl-1" v-if="inEditMode">
                                            <v-btn
                                                v-if="inEditMode"
                                                class="ml-2 mr-2"
                                                color="secondary"
                                                @click="removeContactClick(index, item)"
                                            >
                                                <v-icon small>fa-trash</v-icon>
                                            </v-btn>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="pl-1">
                                            <InputField
                                                :readonly="!inEditMode"
                                                :maxlength="50"
                                                v-model="contact.name"
                                                :errorBorder="!contactValidation.name"
                                                :label="$t('fields.name')"
                                            ></InputField>
                                        </td>
                                        <td class="pl-1">
                                            <InputField
                                                :readonly="!inEditMode"
                                                :maxlength="20"
                                                v-model="contact.phone"
                                                :errorBorder="!contactValidation.phone"
                                                :label="$t('fields.phone')"
                                            ></InputField>
                                        </td>
                                        <td class="pl-1">
                                            <InputField
                                                :readonly="!inEditMode"
                                                :maxlength="50"
                                                v-model="contact.email"
                                                :errorBorder="!contactValidation.email"
                                                :label="$t('fields.email')"
                                            ></InputField>
                                        </td>
                                        <td class="pl-1">
                                            <v-btn
                                                v-if="inEditMode"
                                                class="ml-2 mr-2 mt-1"
                                                color="primary"
                                                @click="addContactClick()"
                                            >
                                                <v-icon small>fa-plus</v-icon>
                                            </v-btn>
                                        </td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col cols="12" xl="6" lg="6" md="6">
                <v-card flat>
                    <v-card-title>
                        {{ $t('labels.vatInformation') }}
                    </v-card-title>
                    <v-card-text>
                        <v-row dense wrap>
                            <v-col cols="12">
                                <Dropdown
                                    :readonly="!inEditMode"
                                    v-model="entity.vat_option_id"
                                    :ajax="true"
                                    :data="'vat-options'"
                                    :errorBorder="!entityValidation.vat_option_id"
                                    :label="'* ' + $t('fields.vatApplicable')"
                                ></Dropdown>
                            </v-col>
                            <v-col cols="12">
                                <TextArea
                                    :readonly="!inEditMode"
                                    :maxlength="500"
                                    v-model="entity.vat_exemption_comment"
                                    :errorBorder="!entityValidation.vat_exemption_comment"
                                    :label="$t('fields.vatExemptionComment')"
                                ></TextArea>
                            </v-col>
                            <v-col cols="12">
                                <InputField
                                    :readonly="!inEditMode"
                                    :maxlength="20"
                                    v-model="entity.vat_id"
                                    :errorBorder="!entityValidation.vat_id"
                                    :label="$t('fields.vatId')"
                                ></InputField>
                            </v-col>
                            <v-col cols="12">
                                <CurrencyField
                                    :max="100"
                                    :min="0.0"
                                    :readonly="
                                        !inEditMode ||
                                        (inEditMode && entity.vat_option_id == 3) ||
                                        (inEditMode && entity.vat_option_id == null)
                                    "
                                    v-model="entity.vat_percentage"
                                    :errorBorder="!entityValidation.vat_percentage"
                                    :label="$t('fields.vatPercentage')"
                                    :key="componentKey"
                                ></CurrencyField>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
                <v-card flat>
                    <v-card-title>
                        {{ $t('labels.bankAccount') }}
                    </v-card-title>
                    <v-card-text>
                        <v-row dense wrap>
                            <v-col cols="12">
                                <InputField
                                    :readonly="!inEditMode"
                                    :maxlength="50"
                                    v-model="entity.bank_account_name"
                                    :errorBorder="!entityValidation.bank_account_name"
                                    :label="$t('fields.accountName')"
                                ></InputField>
                            </v-col>
                            <v-col cols="12">
                                <InputField
                                    :readonly="!inEditMode"
                                    :maxlength="11"
                                    v-model="entity.swift"
                                    :errorBorder="!entityValidation.swift"
                                    :label="$t('fields.swiftCode')"
                                ></InputField>
                            </v-col>
                            <v-col cols="12">
                                <InputField
                                    :readonly="!inEditMode"
                                    :maxlength="50"
                                    v-model="entity.bank_name"
                                    :errorBorder="!entityValidation.bank_name"
                                    :label="$t('fields.bankName')"
                                ></InputField>
                            </v-col>
                            <v-col cols="12">
                                <Dropdown2
                                    :readonly="!inEditMode"
                                    v-model="entity.bank_country_id"
                                    :ajax="true"
                                    :data="'countries'"
                                    :errorBorder="!entityValidation.bank_country_id"
                                    :label="$t('fields.country')"
                                ></Dropdown2>
                            </v-col>
                            <v-col cols="12">
                                <InputField
                                    :readonly="!inEditMode"
                                    :maxlength="50"
                                    v-model="entity.account_holder"
                                    :errorBorder="!entityValidation.account_holder"
                                    :label="$t('fields.accountHolderName')"
                                ></InputField>
                            </v-col>
                            <v-col cols="12">
                                <InputField
                                    :readonly="!inEditMode"
                                    :maxlength="34"
                                    v-model="entity.iban"
                                    :errorBorder="!entityValidation.iban"
                                    :label="$t('fields.iban')"
                                ></InputField>
                            </v-col>
                            <v-col cols="12">
                                <InputField
                                    :readonly="!inEditMode"
                                    :maxlength="20"
                                    v-model="entity.routing_number"
                                    :errorBorder="!entityValidation.routing_number"
                                    :label="$t('fields.routingNumber')"
                                ></InputField>
                            </v-col>
                            <v-col cols="12">
                                <NumberField
                                    :max="9999"
                                    :min="0"
                                    :readonly="!inEditMode"
                                    v-model="entity.due_days"
                                    :errorBorder="!entityValidation.due_days"
                                    :label="'* ' + $t('fields.dueDateDays')"
                                ></NumberField>
                            </v-col>
                            <v-col cols="12">
                                <TextArea
                                    :readonly="!inEditMode"
                                    :maxlength="500"
                                    v-model="entity.invoice_notes"
                                    :errorBorder="!entityValidation.invoice_notes"
                                    :label="$t('fields.invoiceNotes')"
                                ></TextArea>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
                <v-card flat>
                    <v-card-title>
                        {{ $t('labels.contractDetails') }}
                    </v-card-title>
                    <v-card-text>
                        <v-row dense>
                            <!-- <v-col cols="12">
                                <TextArea
                                    :readonly="!inEditMode"
                                    :maxlength="500"
                                    v-model="entity.contract_header"
                                    :errorBorder="!entityValidation.contract_header"
                                    :label="$t('fields.contractHeader')"
                                ></TextArea>
                            </v-col> -->
                            <v-col cols="12">
                                <InputField
                                    :readonly="!inEditMode"
                                    :maxlength="50"
                                    v-model="entity.pay_until"
                                    :errorBorder="!entityValidation.pay_until"
                                    :label="'* ' + $t('fields.payUntil')"
                                ></InputField>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-row><v-col></v-col></v-row>
    </v-container>
</template>

<script>
import CheckBox from './trinkets/CheckBox';
import CurrencyField from '@/components/trinkets/CurrencyField';
import Dropdown from './trinkets/Dropdown';
import Dropdown2 from './trinkets/Dropdown2';
import DatePicker from '@/components/trinkets/DatePicker';
import Entity from '../models/Entity';
import EntityContact from '../models/EntityContact';
import InputField from './trinkets/InputField';
import NumberField from '@/components/trinkets/NumberField';
import TextArea from '@/components/trinkets/TextArea';

export default {
    name: 'Entity',
    components: {CurrencyField, CheckBox, DatePicker, Dropdown, Dropdown2, InputField, NumberField, TextArea},
    data: function () {
        return {
            componentKey: 0,
            entity: new Entity({id: this.$route.params.id}),
            entityValidation: new Entity({}, true),
            entityContacts: [],
            contact: new EntityContact({}),
            contactValidation: new EntityContact({}, true),
            initialLoad: false,
            inEditMode: false,
            lockKey: 'entity',
            lockTimer: null,
            template_id: null,
        };
    },
    methods: {
        sendAllTimesheetsToBilling() {
            let vm = this;
            this.$verify(this.$t('alerts.sendingTimesheetsToBilling'), (result) => {
                if (result) {
                    let userId = vm.$myStore.state.user.id;
                    vm.$APICall('post', 'send-timesheets-for-entity/' + vm.entity.id, {userId}, (data, success) => {
                        if (success) {
                            vm.$notify(vm.$t('alerts.timesheetsSuccessfulSentToBilling'));
                        } else {
                            vm.$notify(vm.$t('alerts.basicError'));
                        }
                    });
                }
            });
        },
        generateAndApproveTimesheets() {
            let vm = this;
            this.$verify(this.$t('alerts.generateTimesheetsAndApproveThem'), (result) => {
                if (result) {
                    let userId = vm.$myStore.state.user.id;
                    vm.$APICall('post', 'generate-timesheets-for-entity/' + vm.entity.id, {userId}, (data, success) => {
                        if (success) {
                            vm.$notify(vm.$t('alerts.timesheetsSuccesfulyGeneratedAndApproved'));
                        } else {
                            vm.$notify(vm.$t('alerts.basicError'));
                        }
                    });
                }
            });
        },
        addContactClick() {
            let success = true;

            if (this.contact.name == '') {
                success = false;
                this.contactValidation.name = false;
            } else {
                this.contactValidation.name = true;
            }
            if (this.contact.phone == '') {
                success = false;
                this.contactValidation.phone = false;
            } else {
                this.contactValidation.phone = true;
            }
            if (!this.$checkEmail(this.contact.email)) {
                success = false;
                this.contactValidation.email = false;
            } else {
                this.contactValidation.email = true;
            }

            if (success) {
                let vm = this;
                if (this.entity.id == 0) {
                    this.entityContacts.push(this.contact);
                    this.contact = new EntityContact({});
                } else {
                    vm.$APICall('post', 'entity-contacts-add/' + this.entity.id, vm.contact, (data, succes) => {
                        if (succes) {
                            this.entityContacts.push(this.contact);
                            this.contact = new EntityContact({});
                            vm.$notify(vm.$t('alerts.basicUpdate'));
                            vm.$APICall('get', 'entity-contacts/' + vm.entity.id, {}, (data, succes) => {
                                if (succes) {
                                    let contactsFromData = JSON.parse(JSON.stringify(data));
                                    vm.entityContacts = contactsFromData;
                                }
                            });
                        }
                    });
                }
            }
        },
        editClick() {
            let vm = this;
            this.$setLock(this, this.lockKey + '|' + this.entity.id, (data) => {
                if (data.success) {
                    vm.inEditMode = true;
                    vm.lockTimer = setInterval(() => {
                        vm.$setLock(vm, vm.lockKey + '|' + vm.entity.id);
                    }, 10000);
                } else {
                    vm.$alert(
                        this.$t('alerts.recordLocked')
                            .split('%name%')
                            .join(data.locked_by.first_name + ' ' + data.locked_by.last_name),
                    );
                }
            });
        },

        loadFromTemplate() {
            let vm = this;
            this.$APICall('get', 'entities/' + this.template_id, {}, (data, success) => {
                if (success) {
                    let usableData = JSON.parse(JSON.stringify(data));
                    vm.entity = usableData;
                    vm.entity.id = 0;
                    let moment = require('moment');
                    vm.entity.registration_date = moment().format('YYYY-MM-DD');
                    vm.$nextTick(() => {
                        vm.componentKey += 1;
                    });
                }
            });
        },
        removeContactClick(index, item) {
            if (this.entity.id == 0) {
                this.entityContacts.splice(index, 1);
            } else {
                let vm = this;
                this.$APICall('post', 'entity-contacts-remove/' + item.id, {}, (data, succes) => {
                    if (succes) {
                        vm.$APICall('get', 'entity-contacts/' + vm.entity.id, {}, (data, succes) => {
                            if (succes) {
                                let contactsFromData = JSON.parse(JSON.stringify(data));
                                vm.entityContacts = contactsFromData;
                            }
                        });
                    }
                });
            }
        },
        backClick() {
            this.$router.go(-1);
        },
        saveClick(goBack) {
            let success = true;
            let missingFields = '';

            if (this.entity.name == '') {
                success = false;
                this.entityValidation.name = false;
                missingFields += this.$t('fields.name') + '<br/>';
            } else {
                this.entityValidation.name = true;
            }
            if (this.entity.town == '' || this.entity.town == null) {
                success = false;
                this.entityValidation.town = false;
                missingFields += this.$t('fields.town') + '<br/>';
            } else {
                this.entityValidation.town = true;
            }
            if (this.entity.address == '') {
                success = false;
                this.entityValidation.address = false;
                missingFields += this.$t('fields.address') + '<br/>';
            } else {
                this.entityValidation.address = true;
            }
            if (this.entity.post_code == '') {
                success = false;
                this.entityValidation.post_code = false;
                missingFields += this.$t('fields.postalCode') + '<br/>';
            } else {
                this.entityValidation.post_code = true;
            }
            if (this.entity.country_id == null) {
                success = false;
                this.entityValidation.country_id = false;
                missingFields += this.$t('fields.country') + '<br/>';
            } else {
                this.entityValidation.country_id = true;
            }
            if (this.entity.entity_type_id == null) {
                success = false;
                this.entityValidation.entity_type_id = false;
                missingFields += this.$t('fields.type') + '<br/>';
            } else {
                this.entityValidation.entity_type_id = true;
            }
            if (this.entity.vat_option_id == null) {
                success = false;
                this.entityValidation.vat_option_id = false;
                missingFields += this.$t('fields.vatApplicable') + '<br/>';
            } else {
                this.entityValidation.vat_option_id = true;
            }
            if (this.entity.poc_email != '') {
                if (!this.$checkEmail(this.entity.poc_email)) {
                    success = false;
                    this.entityValidation.poc_email = false;
                    missingFields += this.$t('alerts.emailFailFormat') + '<br/>';
                } else {
                    this.entityValidation.poc_email = true;
                }
            } else {
                this.entityValidation.poc_email = true;
            }
            if (this.entity.pay_until == '') {
                success = false;
                this.entityValidation.pay_until = false;
                missingFields += this.$t('fields.payUntil') + '<br/>';
            } else {
                this.entityValidation.pay_until = true;
            }
            if (this.entity.due_days == '' || this.entity.due_days == null) {
                success = false;
                this.entityValidation.due_days = false;
                missingFields += this.$t('fields.dueDateDays') + '<br/>';
            } else {
                this.entityValidation.due_days = true;
            }
            if (this.entity.vat_option_id != 3 && this.entity.vat_option_id != null) {
                if (this.entity.vat_percentage < 0.01) {
                    success = false;
                    this.entityValidation.vat_percentage = false;
                    missingFields += this.$t('fields.vatPercentage') + '<br/>';
                } else {
                    this.entityValidation.vat_percentage = true;
                }
            }
            if (this.entity.vat_option_id == 3) {
                this.entity.vat_percentage = 0.0;
            } else {
                if (this.entity.vat_id == '') {
                    success = false;
                    this.entityValidation.vat_id = false;
                    missingFields += this.$t('fields.vatId') + '<br/>';
                } else {
                    this.entityValidation.vat_id = true;
                }
            }

            if (success) {
                let vm = this;

                let action = 'post';
                let addition = '';
                if (vm.entity.id != 0) {
                    action = 'put';
                    addition = '/' + vm.entity.id;
                }
                this.$APICall(action, 'entities' + addition, this.entity, (data, success) => {
                    if (success) {
                        if (this.entity.id != 0) {
                            vm.inEditMode = false;
                            vm.$notify(vm.$t('alerts.basicUpdate'));
                            if (this.lockTimer !== null) clearInterval(this.lockTimer);
                            vm.$removeLock(vm, vm.lockKey + '|' + vm.entity.id);
                            vm.$triggerReload();
                            if (goBack) {
                                vm.backClick();
                            }
                        } else {
                            let entID = data['id'];
                            vm.$APICall('post', 'entity-contacts/' + entID, vm.entityContacts, (data, succes) => {
                                if (succes) {
                                    // Postavi stvarni id novog entiteta da ponovni Save radi PUT (ne stvara duplikat)
                                    vm.entity.id = entID;
                                    vm.inEditMode = false;
                                    vm.$notify(vm.$t('alerts.basicAdd'));
                                    vm.$myStore.commit('setBreadcrumbs', [
                                        {text: vm.$t('modules.entities'), href: '/#/entities', disabled: false},
                                        {
                                            text: vm.entity.name + ' (' + vm.entity.id + ')',
                                            href: '/#/entities/' + vm.entity.id,
                                            disabled: true,
                                        },
                                    ]);
                                    if (this.lockTimer !== null) clearInterval(this.lockTimer);
                                    vm.$removeLock(vm, vm.lockKey + '|' + vm.entity.id);
                                    vm.$triggerReload();
                                    if (goBack) {
                                        vm.backClick();
                                    }
                                }
                            });
                        }
                    } else {
                        vm.$notify(vm.$t('alerts.basicError'));
                    }
                    vm.contact = new EntityContact({});
                    vm.contactValidation = new EntityContact({}, true);
                });
            } else {
                let alert = 'Missing fields: <br/> ' + missingFields;
                this.$alert(alert);
            }
        },
    },

    beforeRouteLeave(to, from, next) {
        if (this.inEditMode) {
            let vm = this;
            this.$verify(this.$t('alerts.leaveQuestion'), (result) => {
                if (result) {
                    if (vm.lockTimer !== null) clearInterval(vm.lockTimer);
                    vm.$removeLock(vm, vm.lockKey + '|' + vm.entity.id);
                    next(true);
                } else {
                    next(false);
                }
            });
        } else {
            next(true);
        }
    },
    mounted() {
        if (!this.$myStore.state.loggedIn) {
            this.$router.replace('login');
        }

        let vm = this;
        if (this.entity.id != 0) {
            this.$APICall('get', 'entities/' + this.entity.id, {}, (data, success) => {
                if (success) {
                    let usableData = JSON.parse(JSON.stringify(data));
                    vm.entity = usableData;
                    vm.$APICall('get', 'entity-contacts/' + vm.entity.id, {}, (data, succes) => {
                        if (succes) {
                            let contactsFromData = JSON.parse(JSON.stringify(data));
                            vm.entityContacts = contactsFromData;
                        }
                    });
                    vm.$myStore.commit('setBreadcrumbs', [
                        {
                            text: vm.$t('modules.entities'),
                            href: '/#/entities',
                            disabled: false,
                        },
                        {
                            text: vm.entity.name + ' (' + vm.entity.id + ')',
                            href: '/#/entities/' + vm.entity.id,
                            disabled: true,
                        },
                    ]);
                    vm.$nextTick(() => {
                        vm.initialLoad = true;
                        vm.componentKey += 1;
                    });
                }
            });
        } else {
            this.$myStore.commit('setBreadcrumbs', [
                {
                    text: this.$t('modules.entities'),
                    href: '/#/entities',
                    disabled: false,
                },
                {
                    text: this.$t('modules.newEntity'),
                    href: '/#/entities/0',
                    disabled: true,
                },
            ]);
            this.inEditMode = true;
            this.initialLoad = true;
            let moment = require('moment');
            vm.entity.registration_date = moment().format('YYYY-MM-DD');
        }
    },
};
</script>

<style scoped></style>
